import { FormattedMessage } from 'react-intl';

import { RULE_GROUP, RULE_TYPE } from 'yeself-common/enum/RuleEnum';
import { FEATURE_FLAG_NAMES, FeatureFlags } from 'yeself-common/typings/FeatureFlags';

import { RuleType } from './types';

export const IdentityRules: RuleType[] = [
    {
        label: <FormattedMessage id="SettingsRules.rules.category.context" />,
        options: [
            // @todo: Currently broken. Feature needs to be evaluated
            // {
            //     value: RULE_TYPE.USER_ATTRIBUTE_VALUE,
            //     label: (
            //         <FormattedMessage id="SettingsRules.rules.identity.itemType.userAttributeValue" />
            //     ),
            // },
            {
                value: RULE_TYPE.ROLES,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.roles" />,
            },
            {
                value: RULE_TYPE.USER_IDS,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.userIds" />,
            },
            {
                value: RULE_TYPE.SIGNED_IN,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.signedIn" />,
            },
        ],
    },
    {
        label: <FormattedMessage id="SettingsRules.rules.category.engagementWithCurrentGuide" />,
        options: [
            {
                value: RULE_TYPE.HAS_NOT_FINISHED,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.hasNotFinished" />,
            },
            {
                value: RULE_TYPE.HAS_NOT_COMPLETED,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.hasNotCompleted" />,
            },
            {
                value: RULE_TYPE.HAS_NOT_SEEN,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.hasNotSeen" />,
            },
        ],
    },
    {
        label: <FormattedMessage id="SettingsRules.rules.category.engagementWithRelatedGuide" />,
        options: [
            {
                value: RULE_TYPE.FINISHED_RELATED_GUIDE,
                label: (
                    <FormattedMessage id="SettingsRules.rules.identity.itemType.finishedRelatedGuide" />
                ),
            },
            {
                value: RULE_TYPE.COMPLETED_RELATED_GUIDE,
                label: (
                    <FormattedMessage id="SettingsRules.rules.identity.itemType.completedRelatedGuide" />
                ),
            },
            {
                value: RULE_TYPE.HAS_NOT_SEEN_RELATED_GUIDE,
                label: (
                    <FormattedMessage id="SettingsRules.rules.identity.itemType.hasNotSeenRelatedGuide" />
                ),
            },
            {
                value: RULE_TYPE.SEEN_RELATED_GUIDE,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.seenRelatedGuide" />,
            },
        ],
    },
    {
        label: <FormattedMessage id="SettingsRules.rules.category.occurrence" />,
        options: [
            {
                value: RULE_TYPE.SHOULD_SEE_GUIDE,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.shouldSeeGuide" />,
            },
            {
                value: RULE_TYPE.LAST_SEEN_GUIDE,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.lastSeenGuide" />,
            },
            {
                value: RULE_TYPE.COMPLETED_COUNT,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.completedCount" />,
            },
            {
                value: RULE_TYPE.INTERACTED_WITH,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.interactedWith" />,
            },
            {
                value: RULE_TYPE.VISITED_COUNT,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.visitedCount" />,
            },
            {
                value: RULE_TYPE.FINISHED_COUNT,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.finishedCount" />,
            },
            {
                value: RULE_TYPE.SEEN_COUNT,
                label: <FormattedMessage id="SettingsRules.rules.identity.itemType.seenCount" />,
            },
        ],
    },
];

export const VisitorRules: RuleType[] = [
    {
        label: <FormattedMessage id="SettingsRules.rules.category.context" />,
        options: [
            {
                value: RULE_TYPE.ADOPT_LANGUAGES,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.adoptLanguages" />,
                featureFlag: FEATURE_FLAG_NAMES.ADOPT_1_0_COMPANY,
            },
            {
                value: RULE_TYPE.ADOPT_LOCATIONS,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.adoptLocations" />,
                featureFlag: FEATURE_FLAG_NAMES.ADOPT_1_0_COMPANY,
            },
            {
                value: RULE_TYPE.ADOPT_ROLES,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.adoptRoles" />,
                featureFlag: FEATURE_FLAG_NAMES.ADOPT_1_0_COMPANY,
            },
        ],
    },
    {
        label: <FormattedMessage id="SettingsRules.rules.category.custom" />,
        options: [
            {
                value: RULE_TYPE.SEGMENTATION_VALUE,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.segmentationValue" />,
            },
        ],
    },
    {
        label: <FormattedMessage id="SettingsRules.rules.category.engagementWithCurrentGuide" />,
        options: [
            {
                value: RULE_TYPE.HAS_NOT_FINISHED,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.hasNotFinished" />,
            },
            {
                value: RULE_TYPE.HAS_NOT_COMPLETED,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.hasNotCompleted" />,
            },
            {
                value: RULE_TYPE.HAS_NOT_SEEN,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.hasNotSeen" />,
            },
        ],
    },
    {
        label: <FormattedMessage id="SettingsRules.rules.category.engagementWithRelatedGuide" />,
        options: [
            {
                value: RULE_TYPE.FINISHED_RELATED_GUIDE,
                label: (
                    <FormattedMessage id="SettingsRules.rules.visitor.itemType.finishedRelatedGuide" />
                ),
            },
            {
                value: RULE_TYPE.COMPLETED_RELATED_GUIDE,
                label: (
                    <FormattedMessage id="SettingsRules.rules.visitor.itemType.completedRelatedGuide" />
                ),
            },
            {
                value: RULE_TYPE.HAS_NOT_SEEN_RELATED_GUIDE,
                label: (
                    <FormattedMessage id="SettingsRules.rules.visitor.itemType.hasNotSeenRelatedGuide" />
                ),
            },
            {
                value: RULE_TYPE.SEEN_RELATED_GUIDE,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.seenRelatedGuide" />,
            },
        ],
    },
    {
        label: <FormattedMessage id="SettingsRules.rules.category.occurrence" />,
        options: [
            {
                value: RULE_TYPE.SHOULD_SEE_GUIDE,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.shouldSeeGuide" />,
            },
            {
                value: RULE_TYPE.LAST_SEEN_GUIDE,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.lastSeenGuide" />,
            },
            {
                value: RULE_TYPE.COMPLETED_COUNT,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.completedCount" />,
            },
            {
                value: RULE_TYPE.INTERACTED_WITH,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.interactedWith" />,
            },
            {
                value: RULE_TYPE.VISITED_COUNT,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.visitedCount" />,
            },
            {
                value: RULE_TYPE.FINISHED_COUNT,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.finishedCount" />,
            },
            {
                value: RULE_TYPE.SEEN_COUNT,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.seenCount" />,
            },
            {
                value: RULE_TYPE.FACES_GUIDE,
                label: <FormattedMessage id="SettingsRules.rules.visitor.itemType.facesGuide" />,
            },
        ],
    },
];

const ruleTypes = () => ({
    [RULE_GROUP.IDENTITY]: IdentityRules,
    [RULE_GROUP.VISITOR]: VisitorRules,
});

export const ruleTypesByGroup = (
    group: typeof RULE_GROUP[keyof typeof RULE_GROUP],
    featureFlags?: FeatureFlags
): RuleType[] => {
    const rules = ruleTypes()[group];

    return featureFlags
        ? rules
              .map((ruleType) => {
                  const options = ruleType.options.filter((option) =>
                      option.featureFlag ? featureFlags[option.featureFlag] : true
                  );
                  return {
                      ...ruleType,
                      options,
                  };
              })
              .filter((ruleType) => ruleType.options.length > 0)
        : rules;
};
